// import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
// import instance from "../../../config/Config"


// const initialState = {
//     data: null,
//     loading: false,
//     error: null,
//     galleryResponse: null,
//     multipleImg: null,
// }

// export const GetGalleryList = createAsyncThunk(
//     "GetGalleryList",
//     async (body) => {
//         try {
//             const response = await instance.get(`crm/gallery/fetch-photos?folderFilter=${body.folderFilter}`)
//             return response.data;
//         } catch (error) {
//             return error?.response
//         }
//     }
// )

// export const CreateGallery = createAsyncThunk(
//     "CreateGallery",
//     async (body) => {
//         try {
//             const formData = new FormData();
//             formData.append("g_title", body.g_title);
//             formData.append("g_image", body.g_image[0]);
//             formData.append("g_folder", body.g_folder);
//             const res = await instance.post("/crm/gallery/add-image", formData)
//             return res.data
//         } catch (error) {
//             throw error
//         }
//     }
// )

// // export const addMultipleImages = createAsyncThunk(
// //     "addMultipleImages",
// //     async (body) => {
// //         try {
// //             const formData = new FormData();
// //             formData.append("g_title", body.g_title);
// //             formData.append("g_image", body.g_image);

// //             formData.append("g_folder", body.g_folder);
// //             const res = await instance.post("/crm/employees/upload-multiple-doc ", formData)
// //             return res.data
// //         } catch (error) {
// //             throw error
// //         }
// //     }
// // )

// // export const addMultipleImages = createAsyncThunk(
// //     "addMultipleImages",
// //     async (body) => {
// //         try {
// //             const formData = new FormData();
// //             // Append other fields
// //             formData.append("g_title", body.g_title);
// //             formData.append("g_folder", body.g_folder);

// //             // Append image(s)
// //             if (body.g_image && Array.isArray(body.g_image)) {
// //                 body.g_image.forEach((imgFile, index) => {
// //                     if (imgFile) {
// //                         formData.append("g_image", imgFile);
// //                     }
// //                 });
// //             } else if (body.g_image instanceof File) {
// //                 formData.append("g_image", body.g_image);
// //             }

// //             const res = await instance.post("/crm/employees/upload-multiple-doc", formData);
// //             return res.data;
// //         } catch (error) {
// //             throw error;
// //         }
// //     }
// // );




// export const GallerySlice = createSlice({
//     name: "GallerySlice",
//     initialState,
//     reducers: {},
//     extraReducers: (builder) => {
//         builder.addCase(GetGalleryList.pending, (state) => {
//             state.loading = true;
//             state.galleryResponse = null;
//         });
//         builder.addCase(GetGalleryList.fulfilled, (state, action) => {
//             state.loading = false;
//             state.data = action.payload;
//         });
//         builder.addCase(GetGalleryList.rejected, (state, action) => {
//             state.loading = false;
//             state.error = action.payload?.data;
//         });

//         builder.addCase(CreateGallery.pending, (state) => {
//             state.loading = true;
//             state.galleryResponse = null;
//         });
//         builder.addCase(CreateGallery.fulfilled, (state, action) => {
//             state.loading = false;
//             state.galleryResponse = action.payload;
//         });
//         builder.addCase(CreateGallery.rejected, (state, action) => {
//             state.loading = false;
//             state.error = action.payload?.data;
//         });
//         // builder.addCase(addMultipleImages.pending, (state) => {
//         //     state.loading = true;
//         //     state.galleryResponse = null;
//         // });
//         // builder.addCase(addMultipleImages.fulfilled, (state, action) => {
//         //     state.loading = false;
//         //     state.multipleImg = action.payload;
//         // });
//         // builder.addCase(addMultipleImages.rejected, (state, action) => {
//         //     state.loading = false;
//         //     state.error = action.payload?.data;
//         // });
//     }
// })

// export default GallerySlice.reducer;




import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import instance from "../../../config/Config"


const initialState = {
    data: null,
    loading: false,
    error: null,
    galleryResponse: null,
}

export const GetGalleryList = createAsyncThunk(
    "GetGalleryList",
    async (body) => {
        try {
            const response = await instance.get(`crm/gallery/fetch-photos?folderFilter=${body.folderFilter}`)
            return response.data;
        } catch (error) {
            return error?.response
        }
    }
)

export const CreateGallery = createAsyncThunk(
    "CreateGallery",
    async (body) => {
        try {
            const formData = new FormData();
            formData.append("g_title", body.g_title);
            formData.append("g_image", body.g_image[0]);
            formData.append("g_folder", body.g_folder);
            const res = await instance.post("/crm/gallery/add-image", formData)
            return res.data
        } catch (error) {
            throw error
        }
    }
)
// export const CreateGallery = createAsyncThunk(
//     "CreateGallery",
//     async (formData) => {
//         try {
//             const res = await instance.post("/crm/gallery/add-image", formData);
//             return res.data;
//         } catch (error) {
//             throw error;
//         }
//     }
// );



export const GallerySlice = createSlice({
    name: "GallerySlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(GetGalleryList.pending, (state) => {
            state.loading = true;
            state.data = null;
        });
        builder.addCase(GetGalleryList.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        });
        builder.addCase(GetGalleryList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload?.data;
        });

        builder.addCase(CreateGallery.pending, (state) => {
            state.loading = true;
            state.galleryResponse = null;
        });
        builder.addCase(CreateGallery.fulfilled, (state, action) => {
            state.loading = false;
            state.galleryResponse = action.payload;
        });
        builder.addCase(CreateGallery.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload?.data;
        });
    }
})

export default GallerySlice.reducer;